import React from 'react';

import { H2, H4 } from 'primitives/appTitle';
import AppSection from 'primitives/appSection';

import { PhotographerApplicationDTO } from 'appAPITypes';

import { FormikProps } from 'formik';
import { FormError } from 'primitives/input/formError';
import { ShText } from '@shoootin/translations';
import { JoinPageTranslations } from '../joinPageTranslations';
import {
  ShEnumPhotographerAvailability,
  ShEnumPhotographerTransportation,
  ShTiles,
} from '@shoootin/components-web';
import {
  ShPhotographerAvailabilities,
  ShPhotographerAvailability,
  ShPhotographerTransportation,
  ShPhotographerTransportations,
} from '@shoootin/config';

export const Availability = ({
  form,
}: {
  form: FormikProps<PhotographerApplicationDTO>;
}) => {
  return (
    <AppSection
      className="photograph-availabilities left"
      header={
        <H2>
          <ShText message={JoinPageTranslations.availabilityTitle} />
        </H2>
      }
    >
      <H4>
        {!form.errors.transportation && (
          <ShText message={JoinPageTranslations.transportationSubtitle} />
        )}
        {form.errors.transportation && (
          //@ts-ignore
          <FormError error={form.errors.transportation} />
        )}
      </H4>
      <ShTiles<ShPhotographerTransportation>
        tiles={ShPhotographerTransportations}
        activeTiles={
          form.values.transportation ? [form.values.transportation] : []
        }
        onTilePress={(key) => form.setFieldValue('transportation', key)}
        renderTileLabel={(key: ShPhotographerTransportation) => (
          <ShText message={ShEnumPhotographerTransportation.messages[key]} />
        )}
      />

      <H4>
        {!form.errors.availability && (
          <ShText message={JoinPageTranslations.availabilitySubtitle} />
        )}
        {form.errors.availability && (
          //@ts-ignore
          <FormError error={form.errors.availability} />
        )}
      </H4>

      <ShTiles<ShPhotographerAvailability>
        tiles={ShPhotographerAvailabilities}
        activeTiles={form.values.availability ? [form.values.availability] : []}
        onTilePress={(key) => form.setFieldValue('availability', key)}
        renderTileLabel={(key: ShPhotographerAvailability) => (
          <ShText message={ShEnumPhotographerAvailability.messages[key]} />
        )}
      />
    </AppSection>
  );
};
